import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { CUSTOM_BREAK_POINT } from './Blocks/Block.styled';

export const GNB_HEIGHT = 126;

const GNB = ({ children }) => {
  const [isHide, setIsHide] = useState(false);

  useEffect(() => {
    let prevScroll = window.scrollY;

    const scrollHandler = () => {
      let currentScroll = window.scrollY;

      const isScrollDown = prevScroll <= currentScroll;
      if (currentScroll === 0) {
        setIsHide(false);
      } else {
        setIsHide(isScrollDown);
      }

      prevScroll = currentScroll;
    };

    window.addEventListener('scroll', scrollHandler);

    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, []);

  return <Container isHide={isHide}>{children}</Container>;
};

const Container = styled.nav<{ isHide: boolean }>`
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: ${GNB_HEIGHT}px;
  background-color: var(--bg-color);
  box-shadow: 0px 2px 11px rgba(0, 0, 0, 0.2);

  z-index: 999;

  ${({ isHide }) =>
    isHide &&
    css`
      transform: translateY(-${GNB_HEIGHT}px);

      @media (max-width: ${CUSTOM_BREAK_POINT}px) {
        transform: translateY(-396px);
      }
    `}

  transition: transform 0.25s;
`;

export default GNB;
